import axios from 'axios'
const API_URL = process.env.VUE_APP_API_URL;

export async function getApiData(user) {

    var self = this;

    var config = {
        headers: {
            token: localStorage.getItem("token")
        }
    }
    var body = {
        endereco: user.ENDCOMLPETE
    }
   return await new Promise((resolve, reject) => {
        axios.post(API_URL + "/restfull/geocodingService", body, config).then(resposta => {
            if (resposta.data.Error)
                reject("Erro interno do servidor.");
            else {
                resolve(Object.assign({}, resposta.data.results[0]))
            }
        })
    })
}